import { chef } from 'cookery';
import fieldBaseTpl from '../base';
import './styles';

const fieldComboTpl = (initData = {}) => {
    return fieldBaseTpl(initData);
}

export { fieldComboTpl }